export function buildQueryString(
	obj: Record<string, string | number | boolean | null | undefined>,
) {
	return Object.entries(obj)
		.filter(([, v]) => v !== undefined && v !== null)
		.map(
			([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`,
		)
		.join("&");
}
